<template>
    <div class="content">
        <van-swipe :lazy-render="true" class="imgs" :autoplay="8000" @change="swipeChange" ref="swipe">
            <van-swipe-item v-for="(url, key) in info.imgs" :key="key">
                <div class="imgbox">
                    <!-- <img src="../../../public/img/products/2.jpg"> -->
                    <img :src="url">
                </div>
            </van-swipe-item>
            <template #indicator>
                <div class="indicator">
                    <img
                        v-for="(url, key) in info.imgs"
                        :src="url"
                        :key="key"
                        :class="{active: activedImgIndex === key}"
                        @click="swipeTo(key)">
                </div>
            </template>
        </van-swipe>

        <h1>{{info.itemNo}}</h1>
        <p>{{info.desc}}</p>
        <div class="price">
            <b>FOB price: {{info.price}}</b><br>
            <b>MOQ: {{info.qty}}</b>
        </div>
    </div>
</template>

<script>
import {
    Swipe as VanSwipe,
    SwipeItem as VanSwipeItem,
} from 'vant';

export default {
    name: "ProductDetail",
    data() {
        return {
            info: {},
            activedImgIndex: 0,
        }
    },
    methods: {
        swipeChange(index) {
            this.activedImgIndex = index
        },
        swipeTo(index) {
            this.$refs.swipe.swipeTo(index)
        },
    },
    mounted() {
        this.info = this.$route.query;
        this.info.imgs = this.info.imgs.filter(e => e); 
    },
    components: { VanSwipe, VanSwipeItem }
}
</script>

<style lang="less" scoped>
    .content { padding: 1rem; }
    .imgs { width: 100%; }
    .imgs .imgbox { height: 0; padding-bottom: 100%; position: relative; }
    .imgs .imgbox img { width: 100%; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); }
    .content h1 { background: #dddddd; color: #4c4848; line-height: 1.5rem; margin: 0.5rem 0 0.8rem; padding-left: .8rem; }
    .content p { overflow:hidden; word-break: break-all; text-overflow:ellipsis; display: -webkit-box; -webkit-box-orient:vertical; -webkit-line-clamp:2; margin-bottom: 12px; }
    .content .price { display: block; margin-top: 4px; line-height: 1.5rem; padding: .5rem 0; border-top: 1px dashed #CCC; border-bottom: 1px dashed #CCC; }

    .indicator { position: relative; margin-top: .6rem; }
    .indicator img { width: 3rem; height: 3rem; object-fit: contain; border: 1px solid #4a4a48; margin-right: 4px; }
    .indicator img.active { box-shadow: 0 0px 5px 0 #ff0000ad; border: 1px solid #ff0000ad; }
</style>